"use client";

import { RefObject, useEffect } from 'react';

export function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T>,
  callback: () => void,
  excludeRefs: RefObject<HTMLElement>[] = []
) {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if the click was inside any of the excluded refs
      const clickedOnExcluded = excludeRefs.some(
        excludeRef => 
          excludeRef.current && 
          (excludeRef.current === event.target || excludeRef.current.contains(event.target as Node))
      );
      
      // If click was outside the ref and not on any excluded elements
      if (ref.current && !ref.current.contains(event.target as Node) && !clickedOnExcluded) {
        callback();
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Clean up
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback, excludeRefs]);
}
